export default function Marquee() {
  const text = "BUILD MOMENTUM \u00A0•\u00A0 MASTER MOVEMENT \u00A0•\u00A0 15 DAYS \u00A0•\u00A0";
  return (
    <div
      data-testid="marquee"
      className="border-y border-[#d4af37]/30 py-5 bg-[#0a0a0a] overflow-hidden"
    >
      <div className="animate-marquee">
        <span className="font-display font-black uppercase text-2xl sm:text-4xl tracking-tight text-neutral-200">
          {text}
        </span>
        <span className="font-display font-black uppercase text-2xl sm:text-4xl tracking-tight text-neutral-200">
          {text}
        </span>
      </div>
    </div>
  );
}
